import React from 'react';
import { formatDateTime } from 'services/helpers/format-date';
import { useRegion } from 'common/hooks/region';
import { SnapshotPreview } from './SnapshotPreview';
import { Download } from './Download';
import { Terminal, SnapshotUrl } from '../../../types/Shipping';

interface Props {
  snapshotUrl?: SnapshotUrl;
  terminal?: Terminal;
}

export const TabContent: React.FC<Props> = (props) => {
  const { snapshotUrl, terminal } = props;

  const region = useRegion();

  if (!snapshotUrl) {
    return (
      <div className="mt-8">
        <h2>No data</h2>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 border border-gray-300">
      <div className="space-y-4 p-12">
        {terminal && <img src={terminal.logo} alt={terminal.name} className="" />}
        <h4 className="font-bold">
          {snapshotUrl.time
            ? `${formatDateTime(
                snapshotUrl.date,
                // Time is sent in PST from the BE since terminal screenshots are saved in PST
                `${snapshotUrl.time}-07:00`,
                region.timeZone
              )}: terminal instructions`
            : 'Not available'}
        </h4>
      </div>
      <div className="bg-gray-100 p-12 flex flex-col items-center gap-2">
        <div className="max-h-[300px] overflow-hidden flex">
          <SnapshotPreview url={snapshotUrl.url} />
        </div>
        {snapshotUrl.url && <Download snapshot={snapshotUrl} />}
      </div>
    </div>
  );
};
